app.component("patientInterpreter", {
	templateUrl: "app/src/js/components/patientHeader/patientInterpreter/patientInterpreter.html",
	controller: "patientInterpreterController",
	bindings: {
		hide: "&",
	},
});

app.controller("patientInterpreterController", [
	"$scope",
	"PreOp",
	"NHI",
	"CurrentPatient",
	"PatientAPI",
	"$timeout",
	function ($scope, PreOp, NHI, CurrentPatient, PatientAPI, $timeout) {
		this.$onInit = function () {
			$scope.preop = PreOp;
			$scope.CP = CurrentPatient;
			$scope.PA = PatientAPI;
			this.PA = PatientAPI;
		};

		$scope.saveInterpreter = function () {
			if(!$scope.CP.patient.id) {
				$scope.$ctrl.hide();
				return;
			} 
			$scope.PA.isProcessing = true;
			$scope.PA.update($scope.CP.patient)
				.then(function (resp) {
					$scope.CP.setPatient(resp.data);
					$scope.PA.isProcessing = false;
					$scope.$ctrl.hide();
				})
				.catch(function (err) {
					$scope.PA.isProcessing = false;
					console.error("Failed to save interpreter:", err && err.status);
				});
		};
	},
]);
